import { PROPOSAL_CSS } from "./proposalTheme";

/**
 * The document as a standalone HTML page, ready to be emailed.
 *
 * Taken from the live preview rather than rebuilt, so the client receives the
 * page the rep looked at. The stylesheet travels with it: every selector in
 * PROPOSAL_CSS is scoped under `.pg-scope`, so the wrapper has to be there or
 * the whole thing arrives as unstyled text — which is exactly what happens when
 * only the fragment is sent.
 */
export const buildDocumentHtml = (node, title) => {
  if (!node) throw new Error("There is no document to send yet");
  const body = node.innerHTML;
  if (!body.trim()) throw new Error("The document has not rendered yet");

  return `<!doctype html>
<html lang="en">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>${title || "Document"}</title>
<style>
${PROPOSAL_CSS}
/* The preview sits inside the admin shell; on its own it needs a ground and a
   width of its own. */
body{margin:0;background:#F5F6FC;}
.pg-scope{max-width:900px;margin:0 auto;padding:20px;}
.pg-scope .page{margin-bottom:20px;}
@media print{body{background:#fff;}.pg-scope{padding:0;max-width:none;}}
</style>
</head>
<body><div class="pg-scope">${body}</div></body>
</html>`;
};
